import { InputLabel, makeStyles, Radio } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import useGetAllInterests from "hooks/interestsHooks/useGetAllInterests";
import useCreateNotification from "hooks/notificationHooks/useAppNotification";
import useUpdateNotification from "hooks/notificationHooks/useUpdateNotification";
import React, { useContext } from "react";
//import useGetAllActiveInterest from "hooks/interestsHooks/useGetAllActiveInterest";
// import Switch from "@material-ui/core/Switch";

import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Snackbar from "@material-ui/core/Snackbar";
import Tooltip from "@material-ui/core/Tooltip";
import { FiberManualRecord } from "@material-ui/icons";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MessageIcon from "@material-ui/icons/Message";
import MuiAlert from "@material-ui/lab/Alert";
import "assets/css/tree-dropdown-main.css";
import "assets/css/tree-dropdown.css";
import radioStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import axios from "axios";
import CustomAlert from "components/CustomAlert/CustomAlert";
import CustomModal from "components/CustomModal/CustomModal";
import { allowedExtensions, configUrl, re } from "config";
import { LoginContext } from "contexts/LoginContext";
import useCreateUserNotificationMapping from "hooks/notificationHooks/useCreateUserNotificationMapping";
import useGetUserByUserName from "hooks/userHooks/useGetUserByUserName";
import SweetAlert from "react-bootstrap-sweetalert";
import MathEditor from "views/Components/newEditor/MathEditor";

// import Button from '@material-ui/core/Button';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
var styles = {
  ...radioStyles,
  ...sweetAlertStyle,
};
const useStyles = makeStyles(styles);


function AppNotifications(props) {
  const classes = useStyles();
  const {
    data: userDetails,
    isLoading,
    mutate: getUserDetails,
    error: userFetchError,
  } = useGetUserByUserName();
  const isAlreadyPublished = props.isPublished;
  const [Courses, setCourses] = React.useState([])
  const [editor, setEditor] = React.useState(null);

  const { providerId } = useContext(LoginContext);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }
  function formatDateOnly(date) {
    return date.toISOString().split("T")[0];  // yyyy-mm-dd
  }

  function getMinScheduleDate() {
    const minTime = new Date(Date.now() + 24 * 60 * 60 * 1000); // +24 hours
    return formatDateOnly(minTime);
  }

  function formatDate(date) {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-");
    // +
    // ' ' +
    // [
    //   padTo2Digits(date.getHours()),
    //   padTo2Digits(date.getMinutes()),
    //   padTo2Digits(date.getSeconds()),
    // ].join(':')
  }
  const [model, setModel] = React.useState({
    providerId: providerId,
    notificationId: 0,
    title: "",
    summary: "",
    content: "",
    tag: "",
    readTime: 0,
    coverImage: null,
    isScheduled: false,
    sendDate: formatDate(new Date(new Date().setDate(new Date().getDate() + 1))),
    notificationType: 1 //  1 = Regular, 2 = Reels
  });
  const [pendingTag, setPendingTag] = React.useState("");
  const [publishAlert, setPublishAlert] = React.useState(null);

  console.log('is here1 - ', props.noti)
  React.useEffect(() => {
    console.log('is here2 - ', props.noti)
    if (props.noti) {
      console.log('is here3 - ', props.noti)
      getNotificationDetails(props.noti);
    }
  }, [props.noti]);

  const getNotificationDetails = async (id) => {
    try {
      const res = await axios.get(
        `${configUrl.AssessmentServer}/api/Notification/globalNotificationDetails/${id}`
      );

      const data = res.data.notification;
      const files = res.data.fileNames || {};

      setModel((prev) => ({
        ...prev,
        providerId: data.providerId || providerId,
        notificationId: data.globalNotificationId || 0,
        title: data.title || "",
        summary: data.summary || "",
        content: data.content || "",
        tag: data.tag || "",
        readTime: data.readTime || 0,
        coverImage: data.coverImage || null,
        isScheduled: !!data.sendDate,
        sendDate: data.sendDate
          ? data.sendDate.split("T")[0]
          : formatDate(new Date()),
        notificationType: data.notificationType || 1,
      }));
      setPendingTag(data.tag || "");

      // ===============================
      // REGULAR NOTIFICATION
      // ===============================
      if (data.notificationType === 1) {
        let apiFiles = [];

        Object.keys(files).forEach((key) => {
          const fileGroup = files[key];

          if (fileGroup?.$values && Array.isArray(fileGroup.$values)) {
            fileGroup.$values.forEach((item) => {
              apiFiles.push({
                attachmentId: item.id,
                filePath: item.url
              });
            });
          }
        });

        setFileNames(apiFiles);
      }

      // ===============================
      // REELS STYLE
      // ===============================
      if (data.notificationType === 2) {
        // setSliderImages(props.images || []);
        setSliderImages(
          props.images.map((img, index) => ({
            id: img.id,
            url: img.imageUrl,
            displayOrder: img.displayOrder
          }))
        );
      }

    } catch (error) {
      console.log(error);
      setErrorMessage("Failed to load notification details");
      showErrorSnackBar();
    }
  };
  console.log(allowedExtensions);
  // console.log(model.sendDateTime);
  const [file, setFile] = React.useState([]);
  console.log(file);
  const [filenames, setFileNames] = React.useState([]);
  console.log(filenames);
  const [open, setOpen] = React.useState(false);
  const [error1, setError1] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [subscriptionList, setSubscriptionList] = React.useState([]);
  const [isAllSubscriptionsSelected, setIsAllSubscriptionsSelected] = React.useState(false);
  const [isAllSelected, setIsAllSelected] = React.useState(false);
  const [providersList, setProviders] = React.useState([]);
  const [sliderImages, setSliderImages] = React.useState([]);

  const handleSliderImageChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 5 * 1024 * 1024; // 5MB per image

    let newFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // only images
      if (!file.type.startsWith("image/")) {
        setErrorMessage("Only image files allowed for slider.");
        showErrorSnackBar();
        return;
      }

      if (file.size > maxSize) {
        setErrorMessage("Each image must be less than 5MB.");
        showErrorSnackBar();
        return;
      }

      if (sliderImages.length + newFiles.length >= 8) {
        setErrorMessage("Max 8 slider images allowed.");
        showErrorSnackBar();
        return;
      }

      // duplicate check
      if (
        sliderImages.find((f) => f.name === file.name) ||
        newFiles.find((f) => f.name === file.name)
      ) {
        setErrorMessage("Duplicate image not allowed.");
        showErrorSnackBar();
        return;
      }

      newFiles.push(file);
    }

    setSliderImages((prev) => [...prev, ...newFiles]);
  };

  const deleteSliderImage = (index) => {
    setSliderImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setError1(false);
  };

  const showSnackBar = () => {
    setOpen(true);
  };
  const showErrorSnackBar = () => {
    setError1(true);
  };

  // console.log(filename)
  // const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
  //   birthdayImage
  // );
  // const [eventData, setMessageTemplate] = React.useState(props.data);
  const intrests = useGetAllInterests();
  console.log("props", props);

  const updateNotification = useUpdateNotification();
  console.log(updateNotification.isSuccess);

  const createnotification = useCreateNotification();
  console.log(createnotification.isSuccess);

  const createUserNotifiaction = useCreateUserNotificationMapping();
  const getallinterest = useGetAllInterests();

  const {
    data: interests,
    error: interestsFetchError,
    isLoading: interestsFetchLoading,
  } = useGetAllInterests();

  React.useEffect(() => {
    if (interests) {
      setInterest(
        interests["$values"].map((x, i) => {
          return { ...x, id: i };
        })
      );
    }
  }, [interests]);

  const [Interest, setInterest] = React.useState([]);
  const [extension, setExtesion] = React.useState("");
  console.log(extension);
  const [interestList, setInterestInfo] = React.useState(
    []
    // isCheackAll:false
  );

  console.log("Interest", Interest);
  let d = [];
  let c = [];
  Interest.map((a) => {
    d.push(a.interestId);
    c.push(a.interestId);
  });

  console.log(isAllSelected);

  const handleSelectAll = () => {
    const toggle = !isAllSelected;
    setIsAllSelected(toggle);

    if (toggle) {
      // Add all active interests
      const activeIds = Interest.filter(t => t.isActive).map(t => t.interestId);
      setInterestInfo(activeIds);
    } else {
      setInterestInfo([]); // Clear selection
    }
  };

  const getTagString = () => {
    // If select all  use all active interests
    const selected = isAllSelected
      ? Interest.filter(i => i.isActive).map(i => i.interests)
      : Interest.filter(i => interestList.includes(i.interestId))
        .map(i => i.interests);

    return selected.join(",");
  };

  const onhandlecheckChange = (e) => {
    const value = parseInt(e.target.value, 10);
    const checked = e.target.checked;

    setIsAllSelected(false);

    setInterestInfo((prev) =>
      checked
        ? [...prev, value]
        : prev.filter((id) => id !== value)
    );
  };

  const handleChange = (e) => {
    console.log(e);
    let { name, value } = e.target;
    console.log(value);
    setModel({ ...model, [name]: value });
  };

  let fileInput = React.createRef();

  const deleteFile = (index) => {
    console.log(index);
    let tempFile = fileIn[index];
    let l = fileIn.filter((el) => el !== tempFile);
    console.log(l);
    setFileIn(l);
  };


  const formgefiledetete = async (index) => {
    try {
      const selectedFile = filenames[index];

      await axios.delete(
        `${configUrl.AssessmentServer}/api/Notification/GlobalNotification/attachments/${model.notificationId}/${selectedFile.attachmentId}`
      );

      const updatedFiles = filenames.filter((_, i) => i !== index);
      setFileNames(updatedFiles);

      setShowAlert(
        <CustomAlert
          open={true}
          severity="success"
          alertMessage="Attachment deleted successfully"
        />
      );

    } catch (error) {
      console.log(error);
      setErrorMessage("Failed to delete attachment.");
      showErrorSnackBar();
    }
  };
  const [formData, setFormDate] = React.useState(new FormData());
  const [seleccionArchivo, setSeleccionArchivo] = React.useState(null);
  const [fileIn, setFileIn] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(null)
  const [flag, setFlag] = React.useState(false)

  let filelengthValidate = fileIn.length + filenames.length;

  console.log(filelengthValidate);
  React.useEffect(() => {
    if (pendingTag && Interest.length > 0) {
      const tags = pendingTag.split(",");

      const selectedIds = Interest
        .filter(item => tags.includes(item.interests))
        .map(item => item.interestId);

      setInterestInfo(selectedIds);

      const activeIds = Interest
        .filter(item => item.isActive)
        .map(item => item.interestId);

      const isAll =
        activeIds.length > 0 &&
        activeIds.every(id => selectedIds.includes(id));

      setIsAllSelected(isAll);
    }
  }, [pendingTag, Interest]);
  const handleImageChange = (e) => {
    console.log(e.target.files[0].name);
    const file = e.target.files[0].name;
    const up = [];
    const maxSize = 10 * 1024 * 1024; // 10 MB in bytes

    // console.log(filelengthValidate.length);
    if (!re.exec(e.target.files[0].name)) {
      setErrorMessage(
        "This File Extension Is Not Supported!. Suported One Are As Follow-: jpg,jpeg,gif,png,pdf,mp4,mov,wmv,avi,xlsx,.xls,pptx,ppt,docx,doc. "
      );
      showErrorSnackBar();
      return;
    }
    else if (e.target.files[0].size > maxSize) {
      setErrorMessage("Please upload file less than 10 MB. ");
      showErrorSnackBar();
      return;
    } else if (filelengthValidate >= 4) {
      setErrorMessage("Please do not upload more than 4 files.");
      showErrorSnackBar();
      return;
    } else if (
      fileIn.find((e) => e.name === file) ||
      filenames.find((e) => e === file)
    ) {
      setErrorMessage("Dublicate file is not Attached.");
      showErrorSnackBar();
      return;
    } else {
      setFileIn([...fileIn, e.target.files[0]]);
      console.log(fileIn);
    }
  };

  const handleClick = (e) => {
    e.preventDefault();
    fileInput.current.value = null;
    fileInput.current.click();

    // props.refresh()
  };
  React.useEffect(() => {
    if (updateNotification.isSuccess) {
      setShowAlert(
        <CustomAlert
          open={true}
          openFlag={() => setFlag(flag ? false : true)}
          severity="success"
          alertMessage={'Notification updated successfully'}
        />
      )
      setTimeout(() => {
        console.log("Delayed for 1 second.");
        props.afterFinish();
      }, 2000);
    }
  }, [updateNotification.isSuccess]);

  React.useEffect(() => {
    if (createnotification.isSuccess) {
      setShowAlert(
        <CustomAlert
          open={true}
          openFlag={() => setFlag(flag ? false : true)}
          severity="success"
          alertMessage={'Notification created successfully'}
        />
      )
      setTimeout(() => {
        console.log("Delayed for 1 second.");
        props.afterFinish();
      }, 2000);
    }
  }, [createnotification.isSuccess]);

  const onHandleSubscriptionChange = (event) => {
    const value = parseInt(event.target.value, 10);
    setSubscriptionList(prev =>
      prev.includes(value)
        ? prev.filter(item => item !== value)
        : [...prev, value]
    );
  };

  const onHandleSubscriptionAllChange = (event) => {
    const checked = event.target.checked;
    setIsAllSubscriptionsSelected(checked);
    setSubscriptionList(checked ? [2, 1] : []);
  };
  const setDescriptionText = (descriptionText) => {
    setModel({ ...model, ['content']: descriptionText });
  }
  const showDescriptionEditor = async () => {
    console.log('editor opened')
    setEditor(
      <CustomModal
        modal={true}
        setModal={hidePlayer}
        content={<MathEditor getExpression={setDescriptionText} model={model.content} contentType={4} onFinish={() => hidePlayer()} />}
        showOk={false}
        showCancel={false}
        onCancelClick={() => hidePlayer()}
        title={`Enter Description message`}
        maxWidth="lg"
        fullWidth={true}
        hideTitle={false}
        showHeaderBackground={true}
      />
    );
  };
  const hidePlayer = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setEditor(null);
  };

  const isValidScheduleDate = (dateValue) => {
    if (!dateValue) return false;

    const finalDateTime = mergeDateWithCurrentTime(dateValue);
    const now = new Date();

    return new Date(finalDateTime) > now;
  };

  const handleSendDateChange = (e) => {
    const value = e.target.value;

    if (!isValidScheduleDate(value)) {
      setErrorMessage("Scheduled time cannot be in the past.");
      showErrorSnackBar();
      return;
    }

    setModel({ ...model, sendDate: value });
  };

  function getCurrentISTDateTime() {
    const now = new Date();
    return now;
  }


  function mergeDateWithCurrentTime(dateStr) {
    const selectedDate = new Date(dateStr);
    const now = new Date();

    selectedDate.setHours(now.getHours());
    selectedDate.setMinutes(now.getMinutes());
    selectedDate.setSeconds(now.getSeconds());

    return selectedDate.toISOString();
  }
  // update noti start
  const updateNotificationData = async () => {
    try {
      const tagString = getTagString();

      if (model.isScheduled) {
        const selectedDate = new Date(model.sendDate);
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + 1);

        selectedDate.setHours(0, 0, 0, 0);
        minDate.setHours(0, 0, 0, 0);

        if (selectedDate < minDate) {
          setErrorMessage("Please select a valid future date.");
          showErrorSnackBar();
          return;
        }
      }

      // if (model.isScheduled && !isValidScheduleDate(model.sendDate)) {
      //   setErrorMessage("Scheduled time cannot be in the past.");
      //   showErrorSnackBar();
      //   return;
      // }

      const finalSendDate = mergeDateWithCurrentTime(model.sendDate);

      // ==========================
      // 1. UPDATE MAIN DETAILS
      // ==========================
      const payload = {
        globalNotificationId: model.notificationId,
        title: model.title,
        summary: model.summary,
        content: model.content,
        tag: tagString,
        coverImage: model.coverImage || "",
        readTime: model.readTime,
        isScheduled: model.isScheduled,
        sendDate: model.isScheduled
          ? finalSendDate
          : getCurrentISTDateTime(),
        notificationType: model.notificationType
      };

      await axios.put(
        `${configUrl.AssessmentServer}/api/Notification/GlobalNotification`,
        payload
      );

      // ==================================
      // 2. IF REELS STYLE => UPDATE IMAGES
      // ==================================
      if (model.notificationType === 2) {
        const formData = new FormData();

        let existingIndex = 0;
        let newIndex = 0;

        sliderImages.forEach((img, index) => {

          // Existing API image
          if (!(img instanceof File)) {
            formData.append(
              `ExistingImages[${existingIndex}].ImageId`,
              img.id
            );

            formData.append(
              `ExistingImages[${existingIndex}].DisplayOrder`,
              index + 1
            );

            existingIndex++;
          }

          // New uploaded image
          if (img instanceof File) {
            formData.append(
              `NewImages[${newIndex}].File`,
              img
            );

            formData.append(
              `NewImages[${newIndex}].DisplayOrder`,
              index + 1
            );

            newIndex++;
          }
        });

        await axios.put(
          `${configUrl.AssessmentServer}/api/Notification/GlobalNotification/${model.notificationId}/images`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
      }

      // ==================================
      // 3. IF REGULAR => HANDLE ATTACHMENTS
      // ==================================
      if (model.notificationType === 1) {
        const uploadData = new FormData();

        fileIn.forEach(file => {
          uploadData.append("file", file);
        });

        if (fileIn.length > 0) {
          await axios.post(
            `${configUrl.AssessmentServer}/api/Attachment/globalNotificationAttachment/${model.notificationId}`,
            uploadData
          );
        }
      }

      // ==================================
      // 4. PUBLISH / SCHEDULE API
      // ==================================
      if (!isAlreadyPublished) {
        await axios.post(
          `${configUrl.AssessmentServer}/api/Notification/GlobalNotificationPublished`,
          null,
          {
            params: {
              globalNotificationId: model.notificationId,
              scheduleDate: model.isScheduled
                ? finalSendDate
                : getCurrentISTDateTime(),
              isScheduled: model.isScheduled
            }
          }
        );
      }

      // ==================================
      // SUCCESS
      // ==================================
      setShowAlert(
        <CustomAlert
          open={true}
          severity="success"
          alertMessage={
            isAlreadyPublished
              ? "Notification updated successfully"
              : model.isScheduled
                ? "Notification scheduled successfully"
                : "Notification published successfully"
          }
        />
      );

      setTimeout(() => {
        props.afterFinish();
      }, 1500);

    } catch (error) {
      console.log(error);
      setErrorMessage("Update failed.");
      showErrorSnackBar();
    }
  };
  //update noti end

  const showPublishConfirmation = () => {
    setPublishAlert(
      <SweetAlert
        showCancel
        confirmBtnText="Yes"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        title=""
        onConfirm={() => {
          setPublishAlert(null);
          updateNotificationData();
        }}
        onCancel={() => {
          setPublishAlert(null);
        }}
        focusCancelBtn
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.warning}
      >
        Are you sure you want to publish this notification?
      </SweetAlert>
    );
  };

  return (
    <>

      <form autoComplete="off">
        <GridItem xs={12}>
          <Card style={{ paddingLeft: 10, paddingRight: 10 }}>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MessageIcon />
              </CardIcon>
            </CardHeader>
            <GridContainer>
              <GridItem xs={12} sm={12} md={8}>
                <Card
                // style={{ padding: 5 }}
                >
                  <GridItem xs={12}>
                    <div style={{ marginBottom: 10 }}>
                      <label style={{ fontWeight: "bold" }}>Notification Type</label>

                      <div style={{ display: "flex", gap: 20, marginTop: 5 }}>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={model.notificationType === 1}
                              onChange={() =>
                                setModel({ ...model, notificationType: 1 })
                              }
                              disabled={!!model.notificationId}
                            />
                          }
                          label="Regular Notification"
                        />

                        <FormControlLabel
                          control={
                            <Radio
                              checked={model.notificationType === 2}
                              onChange={() =>
                                setModel({
                                  ...model,
                                  notificationType: 2,
                                })
                              }
                              disabled={!!model.notificationId}
                            />
                          }
                          label="Reels Style Notification"
                        />
                      </div>

                      {model.notificationId ? (
                        <small style={{ color: "gray" }}>
                          Notification type cannot be changed in edit mode.
                        </small>
                      ) : null}
                    </div>
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={<span>Message Title</span>}
                      id="title"
                      success={model.title}
                      error={!model.title}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      required={true}
                      inputProps={{
                        name: "title",
                        onChange: handleChange,
                        value: model.title,
                      }}
                    />
                  </GridItem>
                  {/* {
                    model.notificationType === 1 && ( */}
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={<span>Summary</span>}
                      id="summary"
                      success={model.summary}
                      error={!model.summary}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      required={true}
                      inputProps={{
                        rows: 3,
                        multiline: true,
                        name: "summary",
                        onChange: handleChange,
                        value: model.summary,
                      }}
                    />
                  </GridItem>
                  {/* )
                  } */}
                  <GridItem xs={12}>
                    <GridContainer justify-items={"center"}>
                      {/* <GridItem xs={12} sm={12} md={6}>
                        <CustomInput
                          labelText={<span>Tag</span>}
                          id="tag"
                          success={model.tag}
                          error={!model.tag}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          required={true}
                          inputProps={{
                            rows: 3,
                            multiline: false,
                            name: "tag",
                            onChange: handleChange,
                            value: model.tag,
                          }}
                        />
                      </GridItem> */}
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText={<span>Read Time</span>}
                          id="readTime"
                          success={model.readTime}
                          error={!model.readTime}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          required={true}
                          inputProps={{
                            type: "number",
                            min: 0,
                            rows: 3,
                            multiline: false,
                            name: "readTime",
                            onChange: handleChange,
                            value: model.readTime,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                  </GridItem>
                  <GridItem xs={12} >
                    <small style={{ color: 'gray', fontWeight: 'bold' }}>Content</small>
                    <MathEditor
                      key={model.notificationId}
                      getExpression={setDescriptionText}
                      model={model.content}
                      contentType={4}
                      onFinish={() => hidePlayer()}
                      showOkay={false}
                    />
                  </GridItem>
                </Card>
              </GridItem>

              <GridItem xs={12} sm={12} md={4}>
                <GridItem xs={12}>
                  <div style={{ marginTop: 20 }}>
                    <label style={{ fontWeight: "bold" }}>Schedule Notification</label>

                    <div style={{ display: "flex", gap: 20, marginTop: 10 }}>
                      <FormControlLabel
                        control={
                          <Radio
                            disabled={isAlreadyPublished}
                            checked={model.isScheduled === true}
                            onChange={() => setModel({ ...model, isScheduled: true })}
                            name="scheduleRadio"
                            icon={<FiberManualRecord className={classes.radioUnchecked} />}
                            checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                            classes={{
                              checked: classes.radio,
                              root: classes.radioRoot,
                            }}
                          />
                        }
                        classes={{ label: classes.label }}
                        label={"Schedule Later"}
                      />

                      <FormControlLabel
                        control={
                          <Radio
                            disabled={isAlreadyPublished}
                            checked={model.isScheduled === false}
                            onChange={() => setModel({ ...model, isScheduled: false })}
                            name="scheduleRadio"
                            icon={<FiberManualRecord className={classes.radioUnchecked} />}
                            checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
                            classes={{
                              checked: classes.radio,
                              root: classes.radioRoot,
                            }}
                          />
                        }
                        classes={{ label: classes.label }}
                        label={"Schedule Now"}
                      />
                    </div>
                  </div>
                </GridItem>
                {model.isScheduled && (
                  <GridItem xs={12} sm={6}>
                    <CustomInput
                      labelText={<span>Select Schedule Date</span>}
                      formControlProps={{ fullWidth: true }}
                      inputProps={{
                        type: "date",
                        name: "sendDate",
                        value: model.sendDate,
                        min: getMinScheduleDate(),
                        onChange: handleSendDateChange
                      }}
                    />
                  </GridItem>
                )}

                {/* Interest Section */}

                <Card style={{ padding: 5 }}>
                  <InputLabel style={{ marginTop: -25, marginLeft: 15 }} shrink>
                    <h4><b>Interest</b></h4>
                  </InputLabel>

                  {/* Select All Interests */}
                  <FormGroup row>
                    <FormControlLabel
                      style={{ marginTop: 2 }}
                      control={
                        <Checkbox
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                        />

                      }
                      label={<small>Select All Interests</small>}
                    />
                  </FormGroup>

                  {/* Individual Interests */}
                  <GridContainer style={{ marginLeft: 2 }} justify-items="center">
                    <br />
                    {Interest.map((x) => (
                      x.isActive && (
                        <FormGroup row key={x.interestId}>
                          <FormControlLabel
                            style={{ marginTop: 2 }}
                            control={
                              <Checkbox
                                type="checkbox"
                                value={x.interestId}
                                onChange={onhandlecheckChange}
                                checked={interestList.includes(x.interestId)}
                                disabled={isAllSelected}
                              />
                            }
                            label={x.interests}
                          />
                        </FormGroup>
                      )
                    ))}
                  </GridContainer>
                </Card>
                {/* <Card style={{ paddingLeft: 10, paddingTop: 5 }}>
                  <InputLabel style={{ marginTop: -25, marginLeft: 15 }} shrink>
                    <h4>
                      <b>Cover Image</b>
                    </h4>
                  </InputLabel>
                  <GridContainer>
                    <GridItem xs={11} sm={11} md={11}>
                      <ImageUpload source={model.coverImage} setImageValue={(e) => setModel({ ...model, ['coverImage']: e })}
                      />
                    </GridItem>
                    <GridItem xs={11}>

                    </GridItem>
                  </GridContainer>
                </Card> */}
                {
                  model.notificationType === 1 && (<Card style={{ paddingLeft: 10, paddingTop: 5 }}>

                    <InputLabel style={{ marginTop: -25, marginLeft: 15 }} shrink>
                      <h4>
                        <b>Attachments</b>
                      </h4>
                    </InputLabel>
                    <GridContainer>
                      <GridItem xs={11}>
                        <Tooltip
                          id="uploadImageToolTip"
                          title="Upload Attachment"
                          placement="recurring"
                        // classes={{ tooltip: classes.tooltip
                        // }}
                        >
                          <Button color="rose" onClick={(e) => handleClick(e)}>
                            <CloudUploadIcon
                            //  className={classes.underChartIcons}
                            />
                            Upload Attachment
                          </Button>
                        </Tooltip>
                        <input
                          type="file"
                          multiple={true}
                          onChange={handleImageChange}
                          ref={fileInput}
                          style={{ display: "none" }}
                        />
                      </GridItem>

                      <GridItem xs={11}>
                        {fileIn.map((item, index) => {
                          console.log(item.name);
                          console.log(index);
                          return (
                            <GridContainer>
                              <GridItem>
                                <h6>{item.name} </h6>
                              </GridItem>
                              <GridItem>
                                {/* <span    
                            > */}
                                <HighlightOffIcon
                                  onClick={() => {
                                    deleteFile(index);
                                  }}
                                />
                                {/* </HighlightOffIcon> */}
                                {/* </span> */}
                              </GridItem>
                            </GridContainer>
                          );
                        })}
                      </GridItem>
                      <GridItem xs={11}>
                        {filenames.map((item, index) => {
                          console.log(item);
                          console.log(index);
                          return (
                            <GridContainer>
                              <GridItem>
                                {/* <h6>{item} </h6> */}
                                <h6>{item.filePath.split("/").pop()}</h6>
                              </GridItem>
                              <GridItem>
                                <HighlightOffIcon
                                  onClick={() => {
                                    formgefiledetete(index);
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          );
                        })}
                      </GridItem>
                    </GridContainer>
                  </Card>)
                }
                {model.notificationType === 2 && (< Card style={{ paddingLeft: 10, paddingTop: 5, marginTop: 10 }}>
                  <InputLabel style={{ marginTop: -25, marginLeft: 15 }} shrink>
                    <h4><b>Slider Images (Reels Style)</b></h4>
                  </InputLabel>

                  <GridContainer>
                    <GridItem xs={12}>
                      <Button color="rose" component="label">
                        <CloudUploadIcon />
                        Upload Slider Images
                        <input
                          type="file"
                          hidden
                          multiple
                          accept="image/*"
                          onChange={handleSliderImageChange}
                        />
                      </Button>
                    </GridItem>

                    {/* Preview like reels */}
                    <GridItem xs={12} style={{ display: "flex", gap: 10, marginTop: 10, overflowX: "auto" }}>
                      {sliderImages.map((img, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            width: 120,
                            height: 200,
                            borderRadius: 10,
                            overflow: "hidden",
                            border: "1px solid #ccc"
                          }}
                        >
                          <img
                            src={
                              img instanceof File
                                ? URL.createObjectURL(img)
                                : img.url || img.imageUrl || ""
                            }
                            alt="slider"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover"
                            }}
                          />

                          <HighlightOffIcon
                            style={{
                              position: "absolute",
                              top: 5,
                              right: 5,
                              color: "white",
                              cursor: "pointer",
                              background: "rgba(0,0,0,0.5)",
                              borderRadius: "50%"
                            }}
                            onClick={() => deleteSliderImage(index)}
                          />
                        </div>
                      ))}
                    </GridItem>
                  </GridContainer>
                </Card>)}
              </GridItem>
              <GridItem xs={12} sm={6} md={4}>
              </GridItem>
              <GridItem xs={12} sm={6} md={4}></GridItem>
              <GridItem
                xs={12}
                sm={6}
                md={4}
              >
                <Button
                  color="rose"
                  style={{ marginLeft: 110, marginBottom: 20, textTransform: 'none' }}

                  onClick={() => {
                    console.log(filelengthValidate);
                    let errorText = "";

                    // Common validation
                    if (model.title === "") {
                      errorText += "Please enter title. ";
                    }

                    if (model.content === "") {
                      errorText += "Please enter content. ";
                    }

                    if (model.summary === "") {
                      errorText += "Please enter summary. ";
                    }
                    // TYPE BASED VALIDATION
                    if (model.notificationType === 1) {
                      // Regular Notification


                      if (filelengthValidate > 3) {
                        errorText += "Please do not select more than 3 files. ";
                      }

                    } else if (model.notificationType === 2) {
                      // Reels Style Notification

                      if (sliderImages.length === 0) {
                        errorText += "Please upload at least 1 slider image. ";
                      }

                      if (sliderImages.length > 8) {
                        errorText += "Maximum 8 slider images allowed. ";
                      }
                    }
                    const finalSendDate = mergeDateWithCurrentTime(model.sendDate);
                    if (errorText != "") {
                      setErrorMessage(errorText);
                      showErrorSnackBar();

                      return;
                    } else {
                      if (!model.notificationId) {
                        console.log(file);
                        let reader = new FileReader();
                        const tempFormData = new FormData();
                        const sliderData = new FormData();
                        console.log(fileIn);
                        fileIn.forEach((element) => {
                          tempFormData.append("file", element);

                          console.log(element);
                          // return;
                        });
                        // Slider Images (MAIN FEATURE)
                        sliderImages.forEach((img) => {
                          sliderData.append("Images", img);
                        });
                        // }
                        // setSeleccionArchivo(tempFormData)
                        setFormDate(tempFormData);
                        console.log(tempFormData);
                        console.log(formData);
                        const tagString = getTagString();

                        setModel(prev => ({ ...prev, tag: tagString }));

                        const {
                          providerId,
                          notificationId,
                          title,
                          summary,
                          content,
                          tag,
                          readTime, coverImage, isScheduled, notificationType,
                          sendDate
                        } = model;

                        const notification = {
                          providerId,
                          notificationId,
                          title,
                          summary,
                          content,
                          tag: tagString,
                          readTime,
                          coverImage,
                          isScheduled,
                          notificationType,
                          sendDate: isScheduled === false ? getCurrentISTDateTime() : finalSendDate,
                        };

                        const a = { notification };
                        createnotification.mutate({
                          notification: a,
                          fData: tempFormData,
                          sliderData: sliderData
                        });
                      } else {
                        if (model.notificationId) {
                          showPublishConfirmation();
                        }
                      }
                      // else {

                      //   // this is for update notification block.
                      //   console.log(file);

                      //   const tempFormData = new FormData();
                      //   const sliderData = new FormData();
                      //   console.log(fileIn);
                      //   // reader.onload=()=>{
                      //   fileIn.forEach((element) => {
                      //     tempFormData.append("file", element);

                      //     console.log(element);
                      //     // return;
                      //   });
                      //   // Slider Images (MAIN FEATURE)
                      //   sliderImages.forEach((img) => {
                      //     sliderData.append("Images", img);
                      //   });
                      //   setFormDate(tempFormData);
                      //   console.log(tempFormData);
                      //   console.log(formData);
                      //   const tagString = getTagString();

                      //   setModel(prev => ({ ...prev, tag: tagString }));
                      //   const {
                      //     providerId,
                      //     notificationId,
                      //     title,
                      //     summary,
                      //     content,
                      //     tag,
                      //     readTime, coverImage, isScheduled, notificationType,
                      //     sendDate
                      //   } = model;

                      //   const notification = {
                      //     providerId,
                      //     notificationId,
                      //     title,
                      //     summary,
                      //     content,
                      //     tag: tagString,
                      //     readTime, coverImage, isScheduled,
                      //     notificationType,
                      //     sendDate: isScheduled === false ? getCurrentISTDateTime() : finalSendDate,
                      //   };

                      //   const a = { notification };
                      //   // updateNotification.mutate({
                      //   createnotification.mutate({
                      //     notification: a,
                      //     fData: tempFormData,
                      //     sliderData: sliderData
                      //   });
                      // }
                    }
                  }}
                  disabled={
                    // !model.title || !model.summary || !model.content || updateNotification.isLoading || createnotification.isLoading
                    !model.title ||
                    !model.content ||
                    !model.summary ||
                    updateNotification.isLoading ||
                    createnotification.isLoading
                  }
                >
                  {model.notificationId ? updateNotification.isLoading ? "Updating..." : isAlreadyPublished ? "Update" : "Update & Publish" : createnotification.isLoading ? "Saving..." : "  Save as Draft"}
                </Button>
                &nbsp;
                <Button
                  color="rose"
                  onClick={props.afterFinish}
                  style={{ marginBottom: 20, textTransform: 'none' }}
                >
                  Cancel
                </Button>
              </GridItem>
            </GridContainer>
          </Card >
        </GridItem >
        {
          updateNotification.isError && (
            <CustomAlert
              open={true}
              severity="error"
              alertMessage="Notification update failed"
            />
          )
        }

        {
          createnotification.isError && (
            <CustomAlert
              open={true}
              severity="error"
              alertMessage="Notification creation failed"
            />
          )
        }
        {showAlert}
        {publishAlert}
        <Snackbar
          open={error1}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert onClose={handleClose} severity="error">
            {errorMessage}
          </Alert>
        </Snackbar>
      </form >
      {editor}
    </>
  );
}

export default AppNotifications;
